export function formatVND(str: string | number, decimal = 2) {
  const value = typeof str === 'string' ? parseFloat(str) : str;
  if (isNaN(value)) return '0';

  return (
    value?.toLocaleString('vi-VN', {
      maximumFractionDigits: decimal,
    }) || '0'
  );
}
